'use strict';

const i18n = require('i18next');
const Backbone = require('backbone');
const Snackbar = require('common/util/snackbar');
const Router = require('balus/app/router/index');

/**
 * 同時編集関連の Module
 */
module.exports = Backbone.Model.extend({
    initialize: function(channel) {
        this.listenTo(channel, 'msg:viewer:add', this.viewerAdd);
        this.listenTo(channel, 'msg:viewer:delete', this.viewerRemove);
        this.listenTo(channel, 'msg:diagram:add', this.addDiagram);
        this.listenTo(channel, 'msg:elements:update', this.updateElements);
        this.listenTo(channel, 'msg:project:update', this.updateProject);
        this.listenTo(channel, 'msg:project:delete', this.deleteProject);
        // コメントはユーザの権限によって追加の可否が変化する。
        // msg:comment:create によってコメントを受け付けた後、コメント追加できた後に :notify 付きのイベントを再度発火する。
        this.listenTo(channel, 'msg:comment:create:notify', this.createComment);
        this.listenTo(channel, 'msg:tag:create', this.createTag);
        this.listenTo(channel, 'msg:tag:update', this.updateTag);
        this.listenTo(channel, 'msg:tag:delete', this.deleteTag);
        this.listenTo(channel, 'msg:tag-category:create', this.createTagCategory);
        this.listenTo(channel, 'msg:tag-category:update', this.updateTagCategory);
        this.listenTo(channel, 'msg:tag-category:delete', this.deleteTagCategory);
    },

    setContext: function(context) {
        this._context = context;
    },

    setUser: function(user) {
        this._user = user;
    },

    _isSameGroup(context) {
        return this._context.groupId == context.groupId;
    },

    _isSameProject(context) {
        return this._context.projectId == context.projectId;
    },

    _isSameDiagram(context) {
        return this._isSameProject(context) && this._context.diagramId == context.diagramId;
    },

    _isSameAction(context) {
        return this._isSameProject(context) && this._context.actionId == context.actionId;
    },

    viewerAdd: function(data, context) {
        if(!this._isSameDiagram(context) || !this._isSameAction(context)) {
            return;
        }

        const user = data.user;
        if(this._user && user.id == this._user.id) {
            return;
        }

        Snackbar.info({
            title: i18n.t('diagram:alert.viewer.add', {
                name: user.name}),
            image_url: user.image_url
        });
    },

    viewerRemove: function(data, context) {
        if(!this._isSameDiagram(context) || !this._isSameAction(context)) {
            return;
        }

        const user = data.user;
        if(this._user && user.id == this._user.id) {
            return;
        }

        Snackbar.info({
            title: i18n.t('diagram:alert.viewer.delete', {
                name: user.name}),
            image_url: user.image_url
        });
    },

    updateElements: function(data, context) {
        if(!this._isSameDiagram(context)) {
            return;
        }
        const updatedBy = data.updated_by;
        Snackbar.info({
            title: i18n.t('diagram:alert.elements.update',
                {name: updatedBy.name}),
            image_url: updatedBy.image_url
        });
    },

    updateProject: function(project, context) {
        if (!this._isSameProject(context)) {
            return;
        }

        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.project.update',
                {name: project.name})
        });
    },

    deleteProject: function(project, context) {
        if (!this._isSameProject(context)) {
            return;
        }

        Snackbar.error({
            title: i18n.t(
                'view:concurrent-edit.notify.project.delete',
                {name: project.name})
        });

        // 対象プロジェクトを開いていても何も操作できないので、Groupに強制移動させる
        const groupID = project.group_id || project.groupID;
        Router.navigate(`/groups/${groupID}`, {trigger: true});
    },

    createComment: function(comment, context) {
        if(!this._isSameDiagram(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t('diagram:alert.comment.add',
                {name: comment.author.name}),
            image_url: comment.author.image_url
        });
    },

    createTag: function(tag, context) {
        if(!this._isSameProject(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.tag.create',
                {name: tag.name})
        });
    },

    updateTag: function(tag, context) {
        if(!this._isSameProject(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.tag.update',
                {name: tag.name})
        });
    },

    deleteTag: function(tag, context) {
        if(!this._isSameProject(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.tag.delete',
                {name: tag.name})
        });
    },

    createTagCategory: function(category, context) {
        if(!this._isSameProject(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.tag-category.create',
                {name: category.name})
        });
    },

    updateTagCategory: function(category, context) {
        if(!this._isSameProject(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.tag-category.update',
                {name: category.name})
        });
    },

    deleteTagCategory: function(category, context) {
        if(!this._isSameProject(context)) {
            return;
        }
        Snackbar.info({
            title: i18n.t(
                'view:concurrent-edit.notify.tag-category.delete',
                {name: category.name})
        });
    }
});



// WEBPACK FOOTER //
// ./balus/domain/service/message-notify.js